import { FormContext } from "vee-validate";

export const key = Symbol("forms");

export interface FormApi {
  add(id: string, form: FormContext): void;
  get(id: string): FormContext | undefined;
  has(id: string): boolean;
  remove(id: string): void;
  findByFieldId(id: string): FormContext[];
}

export default function createData() {
  const forms: Map<string, FormContext> = new Map();
  const api: FormApi = {
    add(id, form) {
      forms.set(id, form);
    },
    has(id: string) {
      return forms.has(id);
    },
    get(id) {
      return forms.get(id);
    },
    remove(id: string) {
      const form = forms.get(id);
      if (form === undefined) {
        throw new Error(`Form with ID ${id} not found`);
      }
      forms.delete(id);
    },
    findByFieldId(id) {
      return Array.from(forms.values()).filter(
        (form) => form && id in form.values
      );
    },
  };
  return api;
}
